// @flow
import React from 'react';
import { resizeImage } from 'lib/common';
import './UserButton.scss';

type Props = {
  onClick(): void,
  thumbnail: ?string,
};

const UserButton = ({ onClick, thumbnail }: Props) => {
  const imgUrl = resizeImage(thumbnail, 100, 100);
  const thumbnailImage = thumbnail ? imgUrl : 'https://images.cacheby.com/default_thumbnail.png';
  return (
    <div className="UserButton">
      <div className="thumbnail" onClick={onClick}>
        <img src={thumbnailImage} alt="thumbnail" />
      </div>
    </div>
  );
};

UserButton.defaultProps = {
  thumbnail: 'https://images.cacheby.com/default_thumbnail.png',
};

export default UserButton;



// WEBPACK FOOTER //
// ./src/components/base/UserButton/UserButton.js